
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';

import * as actions from '../../../../actions/device.Action';
import UpdateComponent from './update.component';

class Update extends Component {
    debuger;
    constructor(props) {       
        super(props);
        this.state = {
            id: props.selectedUser.id,
            firstName: props.selectedUser.firstName,
            lastName: props.selectedUser.lastName,
            checkbox: props.selectedUser.checkbox
        }
    }

    onChange = (e) => {
        const value = e.target.value;

        this.setState({
            [e.target.name]: value
        });
    }

    onChangeCheckbox = (evt, data) => {
        this.setState({
            checkbox: data.checked
        });
      }

    onUpdate = () => {        
        const { id, firstName, lastName, checkbox } = this.state;

        const requestData = {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                firstName: firstName,
                lastName: lastName,
                checkbox: checkbox
            })
        };

        fetch(`https://60fbca4591156a0017b4c8a7.mockapi.io/fakeData/${id}`, requestData)
            .then(response => response.json())
            .then(data => {               
                this.props.onClose();
            });
    }

    onClose = () => {
        this.props.onClose();
    }

    render() {
        return (
            <UpdateComponent
                {...{
                    firstName: this.state.firstName,
                    lastName: this.state.lastName,
                    checkbox: this.state.checkbox
                }}
                onUpdate={this.onUpdate.bind(this)}
                onChange={this.onChange}
                onChangeCheckbox={this.onChangeCheckbox.bind(this)}
                onClose={this.onClose.bind(this)} />
        );
    }
}

function mapStateToProps(state) {
    return {
        device: state.deviceReducer.device
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        Object.assign({},
            actions),
        dispatch);
}

Update.displayName = 'Update';

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Update));